// noinspection JSUnusedGlobalSymbols

import { accountsInfoSlice } from './accountsInfo.slice.ts';

export const { setAccount, resetAccountsInfo, setSelectedGroupMapParcel, setLoadingState } =
  accountsInfoSlice.actions;
